const progressBar = document.getElementById('preload-progress');
const progressBarLabel = document.querySelector('#preload-progress+label');
const onProgress = (loaded, max) =>{
  const percent = Math.round( (loaded / max) * 100 );
  progressBar.setAttribute('value', percent.toString(10));
}

//early load script
(async ()=>{
  progressBarLabel.innerHTML="1/7";
  await progressLoad('/media/vendors/createjs/tweenjs.min.js', 'script', evt => onProgress(evt.loaded, 26932));
  progressBarLabel.innerHTML="2/7";
  await progressLoad('/media/vendors/pixi/pixi.min.js', 'script', evt => onProgress(evt.loaded, 477011));
  progressBarLabel.innerHTML="3/7";
  await progressLoad('/media/images/home/city01.jpg', 'image', evt => onProgress(evt.loaded, 239458));
  progressBarLabel.innerHTML="4/7";
  await progressLoad('/media/images/home/city02.jpg', 'image', evt => onProgress(evt.loaded, 173974));
  progressBarLabel.innerHTML="5/7";
  await progressLoad('/media/images/home/city03.jpg', 'image', evt => onProgress(evt.loaded, 209569));
  progressBarLabel.innerHTML="6/7";
  await progressLoad('/media/images/home/city04.jpg', 'image', evt => onProgress(evt.loaded, 79285));
  progressBarLabel.innerHTML="7/7";
  await progressLoad('/media/js/dist/home.bundle.js', 'script', evt => onProgress(evt.loaded, 8311));
  progressBarLabel.innerHTML="";
  onProgress(100, 100);
})();